<template>
    <add-edit-vessel></add-edit-vessel>
</template>

<script>

import vSelect from "vue-select";
import AddEditVessel from "@/layouts/components/vessel-management/addedit-vessel.vue";


export default {
 components : {
   AddEditVessel
 },
};
</script>